/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import {Helmet} from "react-helmet"

import Header from "./header"
import Footer from "./Footer";

const Layout = ({ children }) => {

  return (
    <div className='relative'>
        <Helmet>
            <meta charSet="utf-8" />
            <title>Teamwide</title>
        </Helmet>


        <div className="relative">

            <Header />

            <main className='flex flex-col justify-center align-center items-center' style={{zIndex: "20"}}>{children}</main>

            <Footer />
        </div>
    </div>
  )
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout
